import React from 'react'

import styled from '@emotion/styled'
import {
  cssExtraInformation,
  cssLabelContainer,
  cssPerServingText,
  cssSoldOutText,
  cssSurchargeAmountText,
  cssTitleContainer,
  cssTitleText,
  cssTitleActive,
} from './styles'

type ItemContentProps = {
  recipeName: string
  isOutOfStock: boolean
  surcharge: number | null
  isChecked?: boolean
}

const LabelContainer = styled.div(cssLabelContainer as any)
const TitleContainer = styled.div(cssTitleContainer as any)
const Title = styled.span(
  (props: any) => (props.isChecked ? { ...cssTitleText, ...cssTitleActive } : cssTitleText) as any,
)
const ExtraInformation = styled.div(cssExtraInformation as any)
const SurchargeAmountText = styled.span(cssSurchargeAmountText as any)
const PerServingText = styled.span(cssPerServingText as any)
const SoldOutText = styled.span(cssSoldOutText as any)

export function ItemContent({
  recipeName,
  isOutOfStock,
  surcharge = null,
  isChecked,
}: ItemContentProps) {
  return (
    <LabelContainer>
      <TitleContainer>
        <Title isChecked={isChecked}>{recipeName}</Title>
      </TitleContainer>
      {surcharge && !isOutOfStock && (
        <ExtraInformation>
          <SurchargeAmountText>{`+£${surcharge.toFixed(2)}`}</SurchargeAmountText>
          <PerServingText>per serving</PerServingText>
        </ExtraInformation>
      )}
      {isOutOfStock && <SoldOutText>Sold out</SoldOutText>}
    </LabelContainer>
  )
}
